export type UptimeChipColor =
  "success" | "warning" | "error" | "default" | "secondary" | "info";

type UptimePaletteColor = Exclude<UptimeChipColor, "default">;

export function uptimePaletteColor(
  uptime: number | null,
): UptimePaletteColor | null {
  if (uptime == null) return null;
  if (uptime >= 99) return "success";
  if (uptime >= 90) return "secondary";
  if (uptime >= 80) return "info";
  if (uptime >= 70) return "warning";
  return "error";
}

export function uptimeChipColor(uptime: number | null): UptimeChipColor {
  return uptimePaletteColor(uptime) ?? "default";
}

export function uptimeBgColor(
  uptime: number | null,
  variant: "bar" | "indicator" = "bar",
): string {
  const color = uptimePaletteColor(uptime);
  if (!color) {
    return variant === "bar" ? "action.disabledBackground" : "action.disabled";
  }
  return `${color}.main`;
}

export function uptimeStatusLabel(uptime: number | null): {
  label: string;
  color: UptimeChipColor;
} {
  if (uptime == null) {
    return { label: "Još nema dovoljno podataka", color: "default" };
  }
  if (uptime >= 99) {
    return { label: "Sustav operativan", color: "success" };
  }
  if (uptime >= 90) {
    return { label: "Operativni problemi", color: "secondary" };
  }
  if (uptime >= 80) {
    return { label: "Smanjena dostupnost", color: "info" };
  }
  if (uptime >= 70) {
    return { label: "Ozbiljni problemi", color: "warning" };
  }
  return { label: "Kritični prekidi", color: "error" };
}

export function allianceUptimeIndicatorBg(
  uptime: number | null,
  hasMonitorableLink: boolean,
): string {
  if (!hasMonitorableLink) return "action.disabled";
  return uptimeBgColor(uptime, "indicator");
}
